export default __webpack_public_path__ + "static/media/rodeo-logistics-logo-dark.9901a676.png";